{
  "query": {
    "v1DashboardSearch": true,
    "v1DisputesInternalEnrichedDisputes": true,
    "v1FinancialReportingOrganizationAccountsCurrencies": true,
    "v1FinancialReportingOrganizationAccountsMetadata": true,
    "v1PaymentIntentsWithLegacyCharges": true,
    "v1ReportingCompartmentCachedMetadataKeys": true,
    "v1ReportingExecuteMultiEntityReport": true,
    "v1ReportingMultiEntityReportRunsMultiEntityReportRun": true,
    "v1ReportingMultiEntityReportRunsMultiEntityReportRunResults": true,
    "v1ReportingMultiEntityReportTypes": true,
    "v1ReportingMultiEntityReportTypesReportType": true,
    "v1SigmaAssistantSessionIdChatHistory": true,
    "v1SigmaOrganizationQueries": true,
    "v1SigmaOrganizationQueriesCompartments": true,
    "v1SigmaOrganizationQueriesOrganizationQuery": true,
    "v1SigmaOrganizationQueriesOrganizationQueryDownload": true,
    "v1SigmaOrganizationQueryFiles": true,
    "v1SigmaOrganizationQueryFilesOrganizationQueryFile": true,
    "v1SigmaOrganizationScheduledQueryRuns": true,
    "v1SigmaOrganizationScheduledQueryRunsOrganizationScheduledQueryRunDownload": true,
    "v1SigmaOrganizationSchema": true,
    "v1StripeDataPipelineExportPlans": true
  },
  "mutation": {
    "deleteV1SigmaOrganizationQueryFilesOrganizationQueryFile": true,
    "v1ReportingMultiEntityReportRuns": true,
    "v1SigmaAssistantMessage": true,
    "v1SigmaOrganizationQueries": true,
    "v1SigmaOrganizationQueriesOrganizationQueryCancel": true,
    "v1SigmaOrganizationQueryFiles": true,
    "v1SigmaOrganizationQueryFilesOrganizationQueryFile": true,
    "v1SigmaOrganizationQueryFilesOrganizationQueryFileSubscribe": true,
    "v1SigmaOrganizationQueryFilesOrganizationQueryFileUnsubscribe": true,
    "v1SigmaQueriesReportingQueryExportToSdp": true,
    "v1StripeDataPipelineActivateExportPlan": true,
    "v1StripeDataPipelineCreateExportPlan": true,
    "v1StripeDataPipelineDeactivateExportPlan": true
  },
  "subscription": {}
}